import { Link } from "react-router-dom";
import { Button } from "@/components/ui/Button";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { buildPlayStoreInviteUrl, PLAY_PACKAGE } from "@/lib/invite";
import { OPERATOR } from "@/lib/legal";

const PLAY_URL = `https://play.google.com/store/apps/details?id=${PLAY_PACKAGE}`;

export function DownloadPage() {
  return (
    <LegalLayout
      title="Get Daywia"
      subtitle="Android app — the full Daywia experience."
    >
      <LegalSection title="Google Play">
        <LegalP>
          {OPERATOR.product} is available on Android. Install from Google Play for Frames, Drifts,
          Parallel, contact sync, chat, and creator features.
        </LegalP>
        <div className="flex flex-wrap gap-3 pt-2">
          <a href={PLAY_URL} target="_blank" rel="noopener noreferrer">
            <Button type="button">Open Google Play</Button>
          </a>
          <Link to="/faq">
            <Button type="button" variant="outline">
              Read FAQ
            </Button>
          </Link>
        </div>
      </LegalSection>

      <LegalSection title="Invited by a friend?">
        <LegalP>
          Open your invite link (daywia.com/invite/…) on your phone. On Android we&apos;ll try the
          app first, then Play Store with your referrer attached.
        </LegalP>
        <LegalP>
          Generic install link:{" "}
          <a
            href={buildPlayStoreInviteUrl("00000000-0000-4000-8000-000000000000")}
            className="break-all text-primary dark:text-primary-dark"
            target="_blank"
            rel="noopener noreferrer"
          >
            {PLAY_URL}
          </a>
        </LegalP>
      </LegalSection>

      <LegalSection title="Web site">
        <LegalUl
          items={[
            "daywia.com is for marketing, invite links, and legal policies.",
            "There is no web login or feed — use the Android app to sign in and post.",
            "Questions? See Contact or email support@daywia.com.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Requirements">
        <LegalP>Android 8+ recommended, active internet, and a valid email address.</LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
